import React from 'react';
import { string, func, bool } from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import {
  ChevronRightIcon,
  AppStoreWhiteIcon,
  GooglePlayStoreWhiteIcon,
  Button,
} from '@snapask/common-components';
import Link from '@blueberry/components/Link';

import { sendGTMEvent } from '@blueberry/redux/googleTagManager';
import { goToExternalUrl, goToLandingPage } from '@blueberry/redux/navigation';

import { CLICK_SIGNUP_IN_ARTICLE } from '@blueberry/constants/gtmEvents';
import { PREMIUM, SIGNUP } from '@blueberry/constants/landingPage';

import config from '@blueberry/config';
const { SNAPASK_SITE_ENDPOINT } = config;

import styles from './CTAFooter.scss';

function CTAFooter({
  title,
  subTitle,
  buttonText,
  sendGTMEvent,
  goToExternalUrl,
  goToLandingPage,
  hasContent,
  t,
}) {
  const onCtaClick = () => {
    goToExternalUrl(`${SNAPASK_SITE_ENDPOINT}/${SIGNUP}`);
    sendGTMEvent(CLICK_SIGNUP_IN_ARTICLE);
  };
  return (
    <section className={styles.root}>
      <div className={styles.inner}>
        <div className={styles.contentLeft}>
          <h2 className={styles.heading}>{title}</h2>
          <p className={styles.subheading}>{subTitle}</p>
          {hasContent ? (
            <Button secondary text={buttonText} onClick={onCtaClick} />
          ) : (
            <div className={styles.contentRow}>
              <Link to={t('common:common.appleStoreLink')} newTab>
                <AppStoreWhiteIcon width={142} height={46} />
              </Link>
              <Link to={t('common:common.googlePlayLink')} newTab>
                <GooglePlayStoreWhiteIcon
                  width={149}
                  height={46}
                  className={styles.googleIcon}
                />
              </Link>

              <div
                onClick={() => goToLandingPage(PREMIUM)}
                className={styles.seeMore}
              >
                <span className={styles.text}>
                  {t('home:home.banner.qaOnlyCta')}
                </span>
                <ChevronRightIcon className={styles.arrowIcon} />
              </div>
            </div>
          )}
        </div>
        <div className={styles.contentRight} />
      </div>
    </section>
  );
}

CTAFooter.propTypes = {
  buttonText: string.isRequired,
  goToExternalUrl: func.isRequired,
  goToLandingPage: func.isRequired,
  hasContent: bool.isRequired,
  sendGTMEvent: func.isRequired,
  subTitle: string.isRequired,
  t: func.isRequired,
  title: string.isRequired,
};

export default connect(null, {
  sendGTMEvent,
  goToExternalUrl,
  goToLandingPage,
})(translate(['common', 'home'])(CTAFooter));



// WEBPACK FOOTER //
// ./app/components/CTAFooter/CTAFooter.jsx